export default function gReportConversion(url) {
  if (!window) return false;
  window.goog_report_conversion(url);
  return true;
}
